import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as moment from 'moment';
import { DATE_TIME_FORMAT } from 'src/app/shared/constants/input.constants';

import { IFileDataMySuffix } from 'src/app/shared/model/file-data-my-suffix.model';
import { FileDataMySuffixService } from './file-data-my-suffix.service';
import { LanguageChangeService } from 'src/app/shared/services/language-change.service';

@Component({
    selector: 'jhi-file-data-my-suffix-update',
    templateUrl: './file-data-my-suffix-update.component.html'
})
export class FileDataMySuffixUpdateComponent implements OnInit {
    private _fileData: IFileDataMySuffix;
    isSaving: boolean;
    uploadedOn: string;

    constructor(private fileDataService: FileDataMySuffixService,
         private activatedRoute: ActivatedRoute,
        private languageChangeService: LanguageChangeService,
         ) {
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
            }
    });
         }

    ngOnInit() {
        this.isSaving = false;
        this.activatedRoute.data.subscribe(({ fileData }) => {
            this.fileData = fileData;
        });
    }

    previousState() {
        window.history.back();
    }

    save() {
        this.isSaving = true;
        this.fileData.uploadedOn = moment(this.uploadedOn, DATE_TIME_FORMAT);
        if (this.fileData.id !== undefined) {
            this.subscribeToSaveResponse(this.fileDataService.update(this.fileData));
        } else {
            this.subscribeToSaveResponse(this.fileDataService.create(this.fileData));
        }
    }

    private subscribeToSaveResponse(result: Observable<HttpResponse<IFileDataMySuffix>>) {
        result.subscribe((res: HttpResponse<IFileDataMySuffix>) => this.onSaveSuccess(), (res: HttpErrorResponse) => this.onSaveError());
    }

    private onSaveSuccess() {
        this.isSaving = false;
        this.previousState();
    }

    private onSaveError() {
        this.isSaving = false;
    }
    get fileData() {
        return this._fileData;
    }

    set fileData(fileData: IFileDataMySuffix) {
        this._fileData = fileData;
        this.uploadedOn = moment(fileData.uploadedOn).format(DATE_TIME_FORMAT);
    }
}
